import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UATConstants } from 'src/Common/Models/UATConstants';
import {
  MANAGE_ACTION_CONSTANTS,
} from 'src/manageAction/utils/manageActionConstants';

export const OtherWebApi = createApi({
  reducerPath: 'OtherWebApi',
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.WebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_API);
      const coreAPIToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_CORE_API);
      const graphToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_GRAPH);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      }else {
        console.warn('One or more tokens are missing. Request may not be authorized.');
      }
      return headers;
    },
  }),
  tagTypes: [], // Define the tags for this API
  endpoints: (builder) => ({
    getAMMDashboardTaskList: builder.query<any,any>({
      query: (queryString) => ({
        method: 'GET',
        url: `${UATConstants.ApiPaths.GetAMMDashboardTasks}${queryString}`,
      }),
    }),
  }),
});
